module.exports = "https://www.gc-qa.gnp.com.mx/57d4916d1f3f110541bd9bec860b3bed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/checked.svg
// module id = 8076
// module chunks = 0